import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { CONTACT } from 'config/contact';

const CTASection = () => {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary to-secondary relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Transform Your Communication?
          </h2>
          <p className="text-lg sm:text-xl text-white/90 mb-8 max-w-3xl mx-auto">
            Join hundreds of businesses saving 40-70 hours monthly with intelligent WhatsApp and email automation. Get started with a free automation audit.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Link to="/contact">
              <Button
                variant="default"
                size="lg"
                className="bg-white text-primary hover:bg-white/90"
                iconName="Calendar"
                iconPosition="left"
              >
                Book Free Automation Audit
              </Button>
            </Link>
            <a href={CONTACT.whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button
                variant="outline"
                size="lg"
                className="border-white text-white hover:bg-white/10"
                iconName="MessageCircle"
                iconPosition="left"
              >
                Chat on WhatsApp
              </Button>
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="flex justify-center mb-3">
                <div className="flex items-center justify-center w-12 h-12 bg-white/20 rounded-full">
                  <Icon name="Clock" size={24} color="white" />
                </div>
              </div>
              <div className="text-2xl font-bold text-white mb-1">30 Minutes</div>
              <div className="text-sm text-white/80">Free consultation call</div>
            </div>

            <div className="text-center">
              <div className="flex justify-center mb-3">
                <div className="flex items-center justify-center w-12 h-12 bg-white/20 rounded-full">
                  <Icon name="FileText" size={24} color="white" />
                </div>
              </div>
              <div className="text-2xl font-bold text-white mb-1">Custom Plan</div>
              <div className="text-sm text-white/80">Tailored to your needs</div>
            </div>

            <div className="text-center">
              <div className="flex justify-center mb-3">
                <div className="flex items-center justify-center w-12 h-12 bg-white/20 rounded-full">
                  <Icon name="Rocket" size={24} color="white" />
                </div>
              </div>
              <div className="text-2xl font-bold text-white mb-1">Quick Setup</div>
              <div className="text-sm text-white/80">Live in 2-4 weeks</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;